<template>
    <div>
        <el-dialog title="商品选择" :visible.sync="visible" width="80%" center>
            <div class="content-operator content-border">
                <el-button type="primary" size="small" @click="selectGoodsClickFun">确认</el-button>
            </div>
            <div class="content-query content-border">
                <el-form :inline="true" :model="query" class="demo-form-inline">
                    <el-form-item label="一级分类：">
                        <el-select v-model="goodsTypeIdOne" @change="goodsTypeOneChange">
                            <el-option v-for="(item, index) in goodsTypeOnes" :key="index" :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="二级分类：">
                        <el-select v-model="goodsTypeIdTwo">
                            <el-option v-for="(item, index) in goodsTypeTwos" :key="index" :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="支付方式：">
                        <el-select v-model="query.assetType" name="assetType">
                            <el-option v-for="(item, index) in assetTypes" :key="index" :label="item.label"
                                       :value="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="审核状态：">
                        <el-select v-model="query.checkStatus">
                            <el-option v-for="(item, index) in checkStatuses" :key="index" :label="item.label"
                                       :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="销售状态：">
                        <el-select v-model="query.saleStatus">
                            <el-option v-for="(item, index) in saleStatuses" :key="index" :label="item.label"
                                       :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="　关键词：">
                        <el-input placeholder="请输入关键词" v-model="query.keyword"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitQuery(1)" size="small">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="content-data" v-if="goodses && 0 < goodses.length">
                <el-table :data="goodses"  highlight-current-row border ref="multipleTable"
                          @selection-change="handleSelectionChange">
                    <el-table-column type="selection"/>
                    <el-table-column  label="图片">
                        <template slot-scope="scope">
                            <el-image style="height: 75px; width: 75px; border-radius: 75px;border: rgb(241,242,244) solid 1px;"
                                      :src="dynamicPath + scope.row.iconPath" >
                                <div slot="error" class="image-slot">
                                    <el-image title="加载失败"
                                              src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/qunyiguan/c6d05d1e8c33703186ec1f89743f979.png"/>
                                </div>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column label="名称" prop="name"/>
                    <el-table-column label="售价" prop="price"/>
                    <el-table-column label="审核状态">
                        <template slot-scope="scope">
                            <span>{{checkStatusMap[scope.row.checkStatus]}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="销售状态">
                        <template slot-scope="scope">
                            <span>{{saleStatusMap[scope.row.saleStatus]}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="支付方式">
                        <template slot-scope="scope">
                            <span>{{assetTypeMap[scope.row.assetType]}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="content-data" v-else>
                没有查询到数据
            </div>
            <vue-pager v-bind:datafile="fillData" url="goods/pageGoodsByManager" v-bind:query="query" ref="pager"
                       v-bind:init="true"></vue-pager>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                goodsTypeIdOne: '',
                goodsTypeOnes: [],
                goodsTypeIdTwo: '',
                goodsTypeTwos: [],

                goodses: [],
                checkStatuses: [],
                checkStatusMap: {},
                saleStatuses: [],
                saleStatusMap: {},
                assetTypes: [],
                assetTypeMap: {},

                query: {
                    adminUserId: ''
                },

                checkInputs: [],
                checkAllInput: '',

                spaceTypeMap: {},

                dynamicPath: config.dynamicResourcePath,

                visible: false
            }
        },
        props: {
            multiple: {
                type: Boolean,
                default: true
            },
            success: {
                type: Function,
                require: true
            }
        },
        created() {
            var _this = this;
            _this.query.adminUserId = _this.$common.user_info().userId;
            _this.checkStatuses = _this.$common.enum_config('EGoodsCheckStatus');
            _this.checkStatuses.forEach(item => {
                _this.checkStatusMap[item.name] = item.label;
            });
            _this.saleStatuses = _this.$common.enum_config('EGoodsSaleStatus');
            _this.saleStatuses.forEach(item => {
                _this.saleStatusMap[item.name] = item.label;
            });
            var spaceTypes = _this.$common.enum_config('EGoodsSpaceType');
            spaceTypes.forEach(item => {
                _this.spaceTypeMap[item.name] = item.label;
            });
            _this.assetTypes = _this.$common.enum_config('EAssetType');
            _this.assetTypes.forEach(item => {
                _this.assetTypeMap[item.name] = item.label;
            });
            _this.query.spaceType = _this.$route.query.spaceType;
            _this.findGoodsTypeOne();
        },
        methods: {
            fillData(response) {
                this.goodses = response.items || []
            },
            submitQuery(_num) {
                var _this = this;
                _this.goodses = [];
                _this.$set(_this.query, 'goodsTypeId', _this.goodsTypeIdTwo || _this.goodsTypeIdOne);
                _this.$refs.pager.gotoPage(_num);
            },
            handleSelectionChange(val) {
                this.checkInputs = val;
                console.log(this.checkInputs)
            },
            findGoodsTypeOne() {
                var _this = this;
                _this.$common.my_ajax({
                    url: 'goodsType/pageGoodsTypeByManager',
                    data: {
                        adminUserId: _this.$common.user_info().userId,
                        level: 1
                    },
                    success: function (response) {
                        _this.goodsTypeOnes = response.items;
                    }
                });
            },
            goodsTypeOneChange() {
                var _this = this;
                _this.$common.my_ajax({
                    url: 'goodsType/pageGoodsTypeByManager',
                    data: {
                        parentTypeId: _this.goodsTypeIdOne
                    },
                    success: function (response) {
                        _this.goodsTypeTwos = response.items;
                        _this.goodsTypeIdTwo = '';
                    }
                });
            },
            selectGoodsClickFun() {
                var _this = this;
                if (0 == _this.checkInputs.length) {
                    _this.$message({
                        type: 'error',
                        message: '请先选择数据',
                        duration: 1000,
                    });
                    return false;
                }
                var checkGoodses = [];
                for (var i = 0; i < _this.checkInputs.length; i++) {
                    var checkInput = _this.checkInputs[i];
                    checkGoodses.push(checkInput);
                }
                if (_this.multiple) {
                    _this.success(checkGoodses);
                } else if (1 === checkGoodses.length) {
                    _this.success(checkGoodses[0]);
                } else {
                    _this.$message({
                        message: '请选择一条记录',
                        type: 'success',
                        duration: 1000
                    });
                }
            },
            openDialog() {
                this.visible = true;
            },
            closeDialog() {
                this.visible = false;
            }

        },
    }
</script>
<style scoped>
</style>